import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AnalyticsService } from 'app/client-core/services/analytics-service';

@Component({
  selector: 'app-analytics-button',
  templateUrl: './analytics-button.component.html',
  styleUrls: ['./analytics-button.component.css']
})
export class AnalyticsButtonComponent implements OnInit {
  @Input() type: string;
  @Input() classes: string;
  @Input() eventCategory: string;
  @Input() eventAction: string;
  @Output() buttonClicked = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  click() {
    AnalyticsService.sendEvent(this.eventCategory, this.eventAction);
    this.buttonClicked.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/analytics-button/analytics-button.component.ts